'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = init;

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _components = require('../vue/components');

var _components2 = _interopRequireDefault(_components);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInitialData = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
    var _ref2, _ref3, boxProduct;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _promise2.default.all([data.box.handle ? (0, _functional.getProductData)(data.box.handle) : '']);

          case 2:
            _ref2 = _context.sent;
            _ref3 = (0, _slicedToArray3.default)(_ref2, 1);
            boxProduct = _ref3[0];
            return _context.abrupt('return', {
              box: {
                amount: parseInt(data.box.amount, 10),
                product: boxProduct
              },
              currentCollectionTitle: data.currentCollectionTitle,
              collectionHandle: data.collectionHandle,
              translations: {
                empty: data.translations.empty,
                title: data.translations.title,
                fullTitle: data.translations.fullTitle,
                countMessage: data.translations.countMessage,
                buttonText: data.translations.buttonText,
                buttonContinue: data.translations.buttonContinue,
                buttonAddText: data.translations.buttonAddText,
                buttonAddedText: data.translations.buttonAddedText,
                buttonFullText: data.translations.buttonFullText,
                buttonPreOrderText: data.translations.buttonPreOrderText,
                buttonAddedPreOrderText: data.translations.buttonAddedPreOrderText
              }
            });

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getInitialData(_x) {
    return _ref.apply(this, arguments);
  };
}();

function init(_ref4) {
  var el = _ref4.el;

  var customBox = {
    box: {
      amount: el.dataset.customBoxAmount,
      handle: el.dataset.customBoxProductHandle
    },
    currentCollectionTitle: el.dataset.customBoxCurrentCollectionTitle,
    collectionHandle: el.dataset.customBoxCollectionHandle,
    translations: {
      empty: el.dataset.translationsEmpty,
      title: el.dataset.translationsTitle,
      fullTitle: el.dataset.translationsFullTitle,
      countMessage: el.dataset.translationsCountMessage,
      buttonText: el.dataset.translationsButtonText,
      buttonContinue: el.dataset.translationsButtonContinue,
      buttonAddText: el.dataset.translationsButtonAddText,
      buttonAddedText: el.dataset.translationsButtonAddedText,
      buttonFullText: el.dataset.translationsButtonFullText,
      buttonPreOrderText: el.dataset.translationsButtonPreOrderText,
      buttonAddedPreOrderText: el.dataset.translationsButtonAddedPreOrderText
    }
  };

  getInitialData(customBox).then(function (_data) {
    new _vue2.default({
      components: _components2.default,
      template: '<CustomBox :data="data" />',
      data: function data() {
        return {
          data: _data
        };
      }
    }).$mount(el);
  });

  if (customBox.box.handle === '') {
    var body = document.body || document.documentElement;
    body.classList.add('drw-PushBox-disable');
  }
}